module.exports = __webpack_public_path__ + "img/kia-logo.4eeb6b2e.webp";